import React, { StrictMode } from 'react';
//import ReactDOM from "react-dom/client";
import ReactDOM from "react-dom";

import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

//react-grid-layout
// import "react-grid-layout/css/styles.css";
// import "react-resizable/css/styles.css";

//ant Design
//import 'antd/dist/antd.css';
//import 'antd/dist/reset.css';
// import "@ant - design/flowchart/dist/index.css";

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
// import cubejs from "@cubejs-client/core";
// import { CubeProvider } from "@cubejs-client/react";
//import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider, theme } from 'antd';

const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        //staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime:30000 //30 ثانیه default:300000=5 دقیقه
      },
    },
  });

  // const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  // root.render(
  //   <Provider store={configureStore({})}>
  //   <QueryClientProvider client={queryClient}>
        
  //           <ConfigProvider
  //               theme={{
  //                   //algorithm: theme.darkAlgorithm,

  //                   token: {
  //                       colorPrimary: '#27ae60',
  //                   },
  //               }}
  //           >
  //               {/* <StrictMode> */}
  //               <App />
  //               {/* </StrictMode> */}
                
  //           </ConfigProvider>
  //           {/* <StyleProvider hashPriority="low"> */}
  //           {/* <App /> */}
  //           {/* </StyleProvider> */}
        
  //       <ReactQueryDevtools />
       
  //   </QueryClientProvider>
  //   </Provider>
  // );

  
ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={configureStore({})}>
            <ConfigProvider
                theme={{
                    //algorithm: theme.darkAlgorithm,

                    token: {
                        colorPrimary: '#27ae60',
                    },
                }}
            >
                {/* <StrictMode> */}
                <App />
                {/* </StrictMode> */}
                
            </ConfigProvider>
            {/* <StyleProvider hashPriority="low"> */}
            {/* <App /> */}
            {/* </StyleProvider> */}
        </Provider>
        <ReactQueryDevtools />
    </QueryClientProvider>
    , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
